const MAX_LINES = 3;

export default class ProfessionalExpertiseAreasToggle {
    constructor() {
        this.paragraphs = [...document.querySelectorAll('.js-professional-expertise-areas')];

        if (this.paragraphs.length === 0) return;

        this.bindEvents();
        this.sync();

        window.addEventListener('resize', this.debounce(() => this.sync(), 200));
        window.addEventListener('load', () => this.sync());
    }

    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    }

    sync() {
        this.paragraphs.forEach((paragraph) => {
            if (paragraph.dataset.expanded !== 'true') {
                this.collapse(paragraph);
            }
        });
    }

    collapse(paragraph) {
        const textEl = paragraph.querySelector('.js-expertise-areas-text');
        const toggle = paragraph.querySelector('.js-professional-expertise-toggle');
        if (!textEl || !toggle) return;

        const fullText = paragraph.dataset.fullText;
        const lineHeight = parseFloat(getComputedStyle(paragraph).lineHeight) || 0;
        const maxHeight = lineHeight * MAX_LINES;

        paragraph.classList.remove('line-clamp-3');
        toggle.classList.remove('hidden');
        textEl.textContent = fullText;

        if (paragraph.scrollHeight <= maxHeight + 1) {
            toggle.classList.add('hidden');
            return;
        }

        const items = fullText.split(', ');
        let lo = 0;
        let hi = items.length;
        while (lo < hi) {
            const mid = Math.ceil((lo + hi) / 2);
            textEl.textContent = items.slice(0, mid).join(', ');
            if (paragraph.scrollHeight <= maxHeight + 1) {
                lo = mid;
            } else {
                hi = mid - 1;
            }
        }
        textEl.textContent = items.slice(0, lo).join(', ');

        this.setIcon(toggle, false);
    }

    expand(paragraph) {
        const textEl = paragraph.querySelector('.js-expertise-areas-text');
        const toggle = paragraph.querySelector('.js-professional-expertise-toggle');
        if (!textEl || !toggle) return;

        textEl.textContent = paragraph.dataset.fullText;
        this.setIcon(toggle, true);
    }

    setIcon(toggle, expanded) {
        toggle.querySelector('.js-expertise-toggle-icon-plus')?.classList.toggle('hidden', expanded);
        toggle.querySelector('.js-expertise-toggle-icon-minus')?.classList.toggle('hidden', !expanded);
        toggle.setAttribute('aria-label', expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore);
    }

    bindEvents() {
        document.addEventListener('click', (event) => {
            const toggle = event.target.closest('.js-professional-expertise-toggle');
            if (!toggle) return;

            const paragraph = toggle.closest('.js-professional-expertise-areas');
            if (!paragraph) return;

            const expanded = paragraph.dataset.expanded === 'true';
            paragraph.dataset.expanded = expanded ? 'false' : 'true';

            if (expanded) {
                this.collapse(paragraph);
            } else {
                this.expand(paragraph);
            }
        });
    }
}

new ProfessionalExpertiseAreasToggle();
